import { TELE_BE_V2 } from "../../../constants/env";
import fetchWrapper from "../../../utils/fetch-client";

export const getRoomLinksWhenPlatformIsEKA = async (aid: string) => {
  try {
    const response = await fetchWrapper(`${TELE_BE_V2}/start-tele-process?aid=${aid}`);
    const data = await response.json();
    return {
      host_url: data.host_url,
      guest_url: data.guest_url,
    };
  } catch (err) {
    console.error("Failed to get tele room links", err);
    return undefined;
  }
};
